import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { IntroductionButton } from '@Components/IconButton';
import { useDisclosure } from '@hooks/useDisclosure';
import Introduction from '@Components/Introduction';

import {
  IImpactsOnStakeholdersFormValues,
  StakeholderAnalysisFormValues,
} from '../ImpactsOnStakeholdersFormProvider/types';
import { useImpactsOnStakeholdersForm } from '../ImpactsOnStakeholdersFormProvider';

export const STAKEHOLDER_ANALYSIS_INTRODUCTION_ID = 'stk-analysis-introduction';

const StakeholderAnalysisIntroduction = () => {
  const { control, getValues } = useImpactsOnStakeholdersForm();

  const { introduction } =
    getValues(`stakeholderAnalysis`) ??
    ({} as IImpactsOnStakeholdersFormValues);

  const [isIntroductionOpen, { open, close }] = useDisclosure(!!introduction);

  const stkAnalysisIntroductionEl = document.getElementById(
    STAKEHOLDER_ANALYSIS_INTRODUCTION_ID
  );

  const { completedSection } =
    useWatch({
      name: 'stakeholderAnalysis',
      control,
    }) ?? ({} as StakeholderAnalysisFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <IntroductionButton
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      />
      {isIntroductionOpen &&
        stkAnalysisIntroductionEl &&
        createPortal(
          <Box mt={2}>
            <Introduction
              onDelete={close}
              topic="การวิเคราะห์ผู้มีส่วนได้เสียในห่วงโซ่คุณค่าของธุรกิจ"
              setOpen={open}
              fieldPath="stakeholderAnalysis.introduction"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          stkAnalysisIntroductionEl
        )}
    </>
  );
};

export default StakeholderAnalysisIntroduction;
